
import {
  updatePlantsAfterDelete,
  updatePlantItem
} from '../plant-items/actions';

import { loadFireBase } from '../../lib/firebase';

export const DELETE_PLANT_SUCCESS = 'DELETE_PLANT_SUCCESS';
export const DELETE_PLANT_FAILURE = 'DELETE_PLANT_FAILURE';
export const UPDATE_PLANT_SUCCESS = 'UPDATE_PLANT_SUCCESS';
export const UPDATE_PLANT_FAILURE = 'UPDATE_PLANT_FAILURE';
export const ON_DELETE_PROMPT_MODAL = 'ON_DELETE_PROMPT_MODAL';
export const ON_TOGGLE_DELETE_MODAL = 'ON_TOGGLE_DELETE_MODAL';

const firebase = loadFireBase();

export const deletePlantCall = (userId, plantKeyId) => {
  const base = firebase.base;
  return base.remove(`plants/${plantKeyId}`)
  .then((data) => {
    return {
      message: 'Plant Deleted Successfully.',
      status: 'success'
    }
  })
};

export const deletePlantSuccess = (resp) => ({
  type: DELETE_PLANT_SUCCESS,
  payload: resp,
});

export const deletePlantError = (error) => ({
  type: DELETE_PLANT_FAILURE,
  error: error,
});

export const deletePlant = (userId, plantKeyId) => {
  return function(dispatch) {
    return deletePlantCall(userId, plantKeyId).then(
      resp => {
        dispatch(deletePlantSuccess(resp));
        dispatch(updatePlantsAfterDelete(plantKeyId));
      },
      error => dispatch(deletePlantError(error))
    )
  }
};

export const updatePlantCall = (userId, inputValues, plantKeyId) => {
  const base = firebase.base;
  const req = {
    key: plantKeyId,
    name: inputValues.name,
    userId,
    waterStartTime: inputValues.waterStartTime,
    wateringCycle: inputValues.wateringCycle,
  };
  return base.update(`plants/${plantKeyId}`, {
    data: req,
  })
  .then(() => {
    return req;
  });
};

export const updatePlantSuccess = (resp) => ({
  type: UPDATE_PLANT_SUCCESS,
  payload: resp,
});

export const updatePlantError = (error) => ({
  type: UPDATE_PLANT_FAILURE,
  error: error,
});

export const updatePlant = (userId, inputValues, plantKeyId) => {
  return function(dispatch) {
    return updatePlantCall(userId, inputValues, plantKeyId)
    .then(
      resp => {
        dispatch(updatePlantSuccess(resp));
        dispatch(updatePlantItem(resp));
      },
      error => dispatch(updatePlantError(error))
    );
  }
};

export const onDeletePromptModal = (isActive, plantIdToDelete) => ({
  type: ON_DELETE_PROMPT_MODAL,
  isActive,
  plantIdToDelete
});

export const onToggleDeleteModal = (isActive) => ({
  type: ON_TOGGLE_DELETE_MODAL,
  isActive
});
